import { createFileRoute } from '@tanstack/react-router'
import PageRegisterVerificationHandler from '@/pages/account/register/verification-handler'

export const Route = createFileRoute('/app/account/register/verification/url/$encodedUrl')({
  component: RouteComponent,
})

function RouteComponent() {
  const { encodedUrl } = Route.useParams()
  return <PageRegisterVerificationHandler encodedUrl={encodedUrl} />
}
